document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('globalModal');
    const modalTitle = modal.querySelector('.modal-title');
    const modalBody = modal.querySelector('.modal-body');
    const bsModal = new bootstrap.Modal(modal);

    const calendar = document.getElementById('modal-content-calendar');
    const originalCalendarLocation = document.getElementById('modal-content-layouts');

    // Auto-popup functionality
    if (window.autoPopupSettings && window.autoPopupSettings.enabled) {
        setTimeout(function () {
            // Check if user has dismissed this popup in this session
            const popupDismissed = sessionStorage.getItem('autoPopupDismissed');

            if (!popupDismissed) {
                modalTitle.textContent = window.autoPopupSettings.title || 'Announcement';
                modalBody.innerHTML = window.autoPopupSettings.content || '';

                // Handle auto-close countdown
                let countdownInterval;
                if (window.autoPopupSettings.autoClose) {
                    let timeLeft = window.autoPopupSettings.autoClose;
                    const countdownEl = document.createElement('div');
                    countdownEl.className = 'mt-4 text-center text-muted small countdown-timer';
                    countdownEl.innerHTML = `This will close in <span class="countdown-seconds">${timeLeft}</span> seconds.`;
                    modalBody.appendChild(countdownEl);

                    const secondsSpan = countdownEl.querySelector('.countdown-seconds');

                    countdownInterval = setInterval(() => {
                        timeLeft--;
                        if (secondsSpan) secondsSpan.textContent = timeLeft;

                        if (timeLeft <= 0) {
                            clearInterval(countdownInterval);
                            bsModal.hide();
                        }
                    }, 1000);
                }

                bsModal.show();

                // Mark as shown in this session when user closes it
                modal.addEventListener('hidden.bs.modal', function markDismissed() {
                    sessionStorage.setItem('autoPopupDismissed', 'true');
                    if (countdownInterval) clearInterval(countdownInterval);
                    modal.removeEventListener('hidden.bs.modal', markDismissed);
                }, { once: true });
            }
        }, window.autoPopupSettings.delay);
    }

    // Manual trigger functionality
    document.querySelectorAll('.modal-trigger').forEach(trigger => {
        trigger.addEventListener('click', function () {
            const title = this.getAttribute('data-title') || 'Default Title';
            const contentKey = this.getAttribute('data-content-key');
            const content = document.getElementById(`modal-content-${contentKey}`);

            // Update modal title
            modalTitle.textContent = title;

            // When opening Event Calendar
            if (title === 'Event Calendar') {
                if (calendar) {
                    modalBody.innerHTML = ''; // Clear modal body
                    modalBody.appendChild(calendar); // Move calendar into the modal
                    calendar.classList.remove('hide-calendar');
                } else {
                    modalBody.innerHTML = '<p class="text-danger">Calendar not found.</p>';
                }
                bsModal.show();
                return;
            }

            // For other content
            if (content) {
                const clone = content.cloneNode(true); // Clone the content
                clone.style.display = 'block'; // Ensure it's visible
                modalBody.innerHTML = ''; // Clear modal body
                modalBody.appendChild(clone); // Append it to the modal
            } else {
                modalBody.textContent = 'Content not found.';
            }

            bsModal.show();
        });
    });

    // When modal is closed, move the calendar back to its original location
    modal.addEventListener('hidden.bs.modal', function () {
        if (calendar && originalCalendarLocation) {
            // Move calendar back to its original location
            calendar.classList.add('hide-calendar');
            originalCalendarLocation.parentNode.insertBefore(calendar, originalCalendarLocation.nextSibling);
        }
    });
});